import * as z from "zod";
import { userFacingError } from "../authorization";
import { mutator } from "./mutator";

export const branchVolumeSeedSchema = z.enum(["empty", "live", "fork_source"]);

export const seedBranchVolumesSchema = z.object({
  branchId: z.string(),
  from: branchVolumeSeedSchema,
});

export const seedBranchVolumes = mutator({
  schema: seedBranchVolumesSchema,
  resolve: {
    branch: { kind: "branch", from: "branchId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.branch.workflow.spaceId,
    },
  ],
  description:
    "Seeds a draft’s stored data: empty, or copied from live or its source branch.",
  interactionType: "update",
  fn: async ({ args: { branch } }) => {
    if (branch.name === "main") {
      throw userFacingError("Live’s stored data is the space’s data already.");
    }
  },
});
